import { observable, computed, action, IObservableArray } from "mobx";

import { AppStore } from "./AppStore";
import { CollectionTreeViewStoreBase } from "./CollectionTreeViewStoreBase";
import { CollectionStoreImpl } from "./CollectionStore";
import { NotificationStore } from "./NotificationStore";
import * as DocumentManagement from "../DocumentManagement";
import { Strings } from "../Stores/StringsStore";
import { DialogStore } from "../Stores/DialogStore";

export class MoveTreeViewStore extends CollectionTreeViewStoreBase {

	constructor(collectionStore: CollectionStoreImpl, isMovingDocuments: boolean) {
		super(collectionStore);
		this.isMovingDocuments = isMovingDocuments;
	}

	isMovingDocuments: boolean;

	@action setMoveDestination(destinationCollection: DocumentManagement.CollectionInfo) {
		if (destinationCollection.guid) {
			DocumentManagement.getCollectionHierarchyAsync(destinationCollection.guid).then(result => {
				let parents = result.parentGuids as IObservableArray<string>;
				let destinationIsSubCollectionofSelectedItem: boolean = parents.some(parentItem => { return this.collectionStore.asideTreeViewStore.selectedCollections.some(selectedItem => selectedItem.guid === parentItem); });
				if (destinationIsSubCollectionofSelectedItem) {
					this.collectionStore.collectionMoveWizardState.wizardWarning = true;
					this.collectionStore.collectionMoveWizardState.wizardWarningText = "Moving a collection to a sub collection of its own is not allowed.";
				}
				else {
					this.collectionStore.collectionMoveWizardState.wizardWarning = false;
					this.collectionStore.collectionMoveWizardState.wizardWarningText = "";
					this.currentFocusedCollection = destinationCollection.guid;
				}
			});
		}
		else {
			this.collectionStore.collectionMoveWizardState.wizardWarning = false;
			this.collectionStore.collectionMoveWizardState.wizardWarningText = "";
			this.currentFocusedCollection = destinationCollection.guid;
		}
	}


	//Moves the selected collections to the current selected collection tree node.
	@action moveCollectionItems() {
		let collectionUpdate: DocumentManagement.CollectionContentUpdate = new DocumentManagement.CollectionContentUpdate();
		collectionUpdate.guid = this.currentFocusedCollection;
		collectionUpdate.content = this.collectionStore.getSelectionGuidList();
		DocumentManagement.moveCollectionsToCollectionAsync(collectionUpdate)
			.then(() => {
				DocumentManagement.getRootCollectionsAsync().then(result => {
					if (collectionUpdate.guid) {
						DocumentManagement.getCollectionHierarchyAsync(collectionUpdate.guid).then(hierachy => {
							this.collectionStore.asideTreeViewStore.treePath.replace(hierachy.parentGuids.reverse());
							this.collectionStore.asideTreeViewStore.treePath.push(collectionUpdate.guid);
							this.collectionStore.asideTreeViewStore.pushCollectionTreePathHistory();
						});
					}
					else {
						this.collectionStore.asideTreeViewStore.treePath.clear();
						this.collectionStore.asideTreeViewStore.pushCollectionTreePathHistory();
					}
					this.collectionStore.resetMoveMode();
					this.collectionStore.asideTreeViewStore.selectedCollections.clear();
					this.collectionStore.asideTreeViewStore.model.subCollections.replace(result);
					this.collectionStore.asideTreeViewStore.resolveTreePathCollections(this.collectionStore.asideTreeViewStore.model);
					AppStore.isBusy = false;
					NotificationStore.showSuccessMessage("moved");
				}).catch(error => {
					AppStore.isBusy = false;
					DialogStore.showError(Strings.general.errorDialogTitle, error);
				});
			}).catch(error => {
				AppStore.isBusy = false;
				DialogStore.showError(Strings.general.errorDialogTitle, error);
			});
	}

	/**
	* Moves the selected documents to the current selected collection tree node.
	*/
	@action moveDocumentItems() {
		let collectionUpdate: DocumentManagement.CollectionContentUpdate = new DocumentManagement.CollectionContentUpdate();
		collectionUpdate.guid = this.currentFocusedCollection;
		collectionUpdate.content = this.collectionStore.getSelectionDocumentsGuidList();
		AppStore.isBusy = true;
		DocumentManagement.moveDocumentsToCollectionAsync(collectionUpdate)
			.then(() => {
				DocumentManagement.getRootCollectionsAsync().then(result => {
					this.collectionStore.resetDocumentMove();
					this.collectionStore.documentInfoList.replace(this.collectionStore.documentInfoList.filter((document) => {
						return !collectionUpdate.content.some((guid) => guid == document.guid);
					}));
					AppStore.isBusy = false;
					NotificationStore.showSuccessMessage("moved");
				}).catch(error => {
					AppStore.isBusy = false;
					DialogStore.showError(Strings.general.errorDialogTitle, error);
				});
			}).catch(error => {
				AppStore.isBusy = false;
				DialogStore.showError(Strings.general.errorDialogTitle, error);
			}).catch(error => {
				AppStore.isBusy = false;
				DialogStore.showError(Strings.general.errorDialogTitle, error);
			});
	}

	//Resolve all root collections.
	@action getRoots() {
		this.collectionStore.collectionMoveWizardState.isWizardBoxBusy = true;
		DocumentManagement.getRootCollectionsAsync().then(result => {
			if (!this.isMovingDocuments) {
				let rootNode = new DocumentManagement.CollectionInfo();
				rootNode.name = Strings.documentManagement.collections.moveCollectionRootName;
				result.unshift(rootNode);
			}
			this.model.subCollections.replace(result);
			this.resolveTreePathCollections(this.model);
			this.collectionStore.collectionMoveWizardState.isWizardBoxBusy = false;
		}).catch(error => {
			DialogStore.showError(Strings.general.errorDialogTitle, error);
		});
	}
}